var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"wabident-selector",attrs:{"id":"product_selector","filterable":false,"options":_vm.products,"placeholder":"Busca el tratamiento/producto aquí ..."},on:{"search":_vm.searchProducts,"input":_vm.change},model:{value:(_vm.selected_product),callback:function ($$v) {_vm.selected_product=$$v},expression:"selected_product"}})
}
var staticRenderFns = []

export { render, staticRenderFns }